import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";

export default function Footer({ logoUrl, content }) {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[#1E3F33] text-white/80 pt-14 sm:pt-20 pb-8">
      <div className="container-z">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <a href="#top" className="flex items-center gap-2.5">
              <span className="w-2.5 h-2.5 rounded-full bg-[#C86646]" />
              <img src={logoUrl} alt="Zumroo" className="h-11 w-11 rounded-lg" />
            </a>
            <p className="mt-4 text-sm text-white/60 max-w-xs leading-relaxed">
              Every property. Every connection. Pune's broker–owner property marketplace.
            </p>
          </div>

          <div>
            <div className="text-xs font-bold uppercase tracking-wider text-[#E9C46A] mb-4">Product</div>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/listings" className="hover:text-white">Listings</Link></li>
              <li><Link to="/#how" className="hover:text-white">How it works</Link></li>
              <li><Link to="/#cities" className="hover:text-white">Cities</Link></li>
              <li><Link to="/signin" className="hover:text-white">Get Started</Link></li>
            </ul>
          </div>

          <div>
            <div className="text-xs font-bold uppercase tracking-wider text-[#E9C46A] mb-4">Company</div>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/about" className="hover:text-white">About</Link></li>
              <li><Link to="/#contact" className="hover:text-white">Contact</Link></li>
              <li><Link to="/#faq" className="hover:text-white">FAQ</Link></li>
              <li><Link to="/privacy" className="hover:text-white">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-white">Terms of Use</Link></li>
              <li><Link to="/admin/login" className="hover:text-white">Admin sign in</Link></li>
            </ul>
          </div>

          <div>
            <div className="text-xs font-bold uppercase tracking-wider text-[#E9C46A] mb-4">Reach us</div>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-2.5">
                <Phone className="w-4 h-4 text-white/50" />
                <span>{content.contact_phone}</span>
              </li>
              <li className="flex items-center gap-2.5">
                <Mail className="w-4 h-4 text-white/50" />
                <span>{content.contact_email}</span>
              </li>
              <li className="flex items-center gap-2.5">
                <MapPin className="w-4 h-4 text-white/50" />
                <span>Pune, Maharashtra, India</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between text-xs text-white/50">
          <span>© {year} Zumroo. All rights reserved.</span>
          <span>Made in India · for Indian brokers.</span>
        </div>
      </div>
    </footer>
  );
}
